package com.arena_web.data.api

import com.arena_web.data.dto.*
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiGet
import com.arena_web.data.http.apiPost
import io.ktor.client.*

class SubscriptionApi(private val client: HttpClient) {

    suspend fun getSubscription(): ApiResponse<SubscriptionDto> {
        return client.apiGet("v1/users/me/subscription")
    }

    suspend fun checkout(source: String?, trial: Boolean = false): ApiResponse<SubscriptionCheckoutDto> {
        return client.apiPost("v1/users/me/subscription/checkout", SubscriptionCheckoutRequest(source, trial))
    }

    suspend fun confirmCheckout(request: SubscriptionConfirmRequest): ApiResponse<SubscriptionDto> {
        return client.apiPost("v1/users/me/subscription/checkout/confirm", request)
    }

    suspend fun cancel(): ApiResponse<SubscriptionDto> {
        return client.apiPost("v1/users/me/subscription/cancel")
    }
}
